import type { SVGProps } from 'react'
import { useTheme } from '@mui/material/styles'

export const HlLogo = (props: SVGProps<SVGSVGElement>) => {
  const theme = useTheme()
  const fill = theme.palette.background.default

  return (
    <svg
      width="36"
      height="36"
      viewBox="0 0 36 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.9943 28.0166L35.2473 27.9531V35.248H19.0432V31.3057C28.0733 29.3871 32.8629 28.3746 35.2473 27.8896L34.9943 28.0166ZM16.9572 0.751953V11.1885H19.0461V0.751953H34.8703C34.83 0.779964 27.0432 6.18763 19.0461 12.6016C5.50002 23.4599 -8.65821 37.1639 13.1379 32.5254L16.9572 31.7246V35.2451H0.752151V0.751953H16.9572ZM35.2482 25.2109C30.2687 25.9489 24.5713 26.4766 19.0432 26.9404V22.8291H16.9543V27.1084L14.2961 27.3193C-0.241492 28.4789 30.8378 4.78155 35.2482 1.42871V25.2109Z"
        fill={fill}
      />
    </svg>
  )
}
